import { AppointmentTypeTimeslotsRequest } from "@/apiGenerate/medserver";

export enum CalendarView {
    WEEK = "timeGridWeek", 
    DAY = "timeGridDay"
}

export interface ApointmentTypeTimeslotsWithIndex {
    index: string,
    apointmentTypeTimeslots: AppointmentTypeTimeslotsRequest;
}

export const codeErrorNoPlanning = "HAS_NO_PLANNING";

export const defaultLocal = "fr";
export const enLocal = "en";

export const appointment_duration_min = 5; // 5 minutes
export const appointment_duration_max = 1439; // 23 hours 59 minutes

export const NO_BADGE = "NO_BADGE";
